export default __webpack_public_path__ + "assets/svg/close_icon_gray.a1b7126eaca1a97fde04baba273e9062.svg";